<template>
  <div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="标题" width="300">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="文件类型" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">.{{scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下载量" width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.downNum }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="评分" width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ 1 }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="价格" width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.money || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上传日期" width="120">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ YearMMdd(scope.row.time) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding:20px;text-align:center;">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="currentchange"></el-pagination>
    </div>
  </div>
</template>

<script>

import { getMyArctilce,delById } from '@/services'
import api from '@/services/config.js'

export default {
  data() {
    return {
      tableData: [],
      pageIndex:1,
      pageSize:10,
      total:0
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let tk = localStorage.getItem('token');
      let ui = sessionStorage.getItem('userInfo');
      let userInfo = {};
      if (!tk) {
        this.$message({
          message: '请登陆',
          type: 'warning'
        })
        return
      }
      try {
        userInfo = JSON.parse(ui);
      } catch (error) {

      }
      let data = {
        userId: userInfo.id,
        type: 3,
        pageIndex:this.pageIndex,   //当前页
        pageSize: this.pageSize    //每页大小
      }

      this.tableData = [];

      getMyArctilce(data).then(res => {
        if (res.success) {
          this.tableData = res.data.records || [];
          this.total = res.data.total||0
        }
      })
    },

    currentchange(e){
      this.pageIndex = e;
      this.init()
    },

    handleDelete(item) {
      let data = {id:item.id,type:2};
      delById(data).then(res=>{
        if(res.success){
          this.init();
        }else{
          this.$message({
            message:res.message,
            type:'warning'
          })
        }
      })
    },

    YearMMdd(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
    }
  },
};
</script>
<style scoped>
.el-table .cell {
  white-space: nowrap !important;
}
</style>
